import apiUrl from '../../../constants';
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import PageTracker from '../../../common/PageTrackerHelper'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import Paginate from "vuejs-paginate";

export default {
    name: 'RvpFlierTracking',
    components: {
        VueElementLoading,
        Paginate
    },
    mixins: [PageTracker],
    data: function () {
        return {
            flyerbarcode: '',
            shippingid: '',
            pagecount: 1,
            pageNo: '1',
            shipmentData: [],
            isLoading: false,
            showTable: false,
            userDataKey : '',
        }
    },
    created: function () {
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata');
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.localhubdetails = userdetail.hubdetails[0];

        // let TrackerInfo = {
        //     projectname: "Last Mile",
        //     type: "Web",
        //     userid: this.localuserid,
        //     username: this.localusermailid,
        //     meta: {
        //         "event": ""
        //     }
        // }
        // let result = this.PageTracker(TrackerInfo);
    },
    methods: {
        FlyerbarcodeShipmentDetails() {
            if (this.shippingid == '' && this.flyerbarcode == '') {
                this.$alertify.error("Please select either ShippingID or Flyerbarcode!")
            }
            else {
                this.shipmentData = [];
                this.showTable = false;
                this.isLoading = true;
                let payload = {
                    limit:"10",
                    pageNo:this.pageNo.toString(),
                }
                if(this.shippingid != ''){
                    payload.shippingid = this.shippingid
                }
                if(this.flyerbarcode != ''){
                    payload.flyerbarcode = this.flyerbarcode
                }
                axios.post(apiUrl.api_url + 'expose/get/flyerbarcode/log',payload)
                .then((response) => {
                    this.showTable = true;
                    if (response.data.code == 200) {
                        this.shipmentData = response.data.data.rows;
                        this.pagecount = Math.ceil(response.data.data.count/10)
                    } else {
                        this.$alertify.error(response.data.message)
                    }
                    this.isLoading = false;
                    this.pagecount = 1
                },
                )
            }
        },
        getPaginationData(pageNum) {
            this.pageNo = pageNum;
            this.FlyerbarcodeShipmentDetails();
        },
        clear() {
            this.shipmentData = []
            this.pagecount = 0;
            this.pageNo = 1;
            this.$validator.reset();
            this.errors.clear();
            this.shippingid = '';
            this.flyerbarcode = '';
            this.showTable = false;
            this.isLoading = false;
        },
    },
}



// WEBPACK FOOTER //
// ./src/views/components/RvpFlierTracking/RvpFlierTracking.component.js